import { EmptyState } from '@/components/EmptyState/EmptyState';
import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';
import { useAmelioTranslations } from '@/hooks';

export interface CalibrationCyclesPlaceholderProps {
    isLoading: boolean;
    isError: boolean;
}

/**
 * What the page shows in place of the report while there is no cycle to report on: the cycle list
 * loading, failing, or coming back empty. Kept apart from the report's own states so each one
 * reads as a single early return, and so the page header stays on screen in all three.
 */
export const CalibrationCyclesPlaceholder = ({
    isLoading,
    isError,
}: CalibrationCyclesPlaceholderProps) => {
    const { t } = useAmelioTranslations();

    if (isLoading) {
        return (
            <Skeleton className={'flex flex-col gap-4'}>
                <Bone className={'h-24 w-full'} />

                <Bone className={'h-80 w-full'} />
            </Skeleton>
        );
    }

    if (isError) {
        return (
            <EmptyState
                title={t('calibration.errors.loadCycles.title')}
                message={t('calibration.errors.loadCycles.message')}
            />
        );
    }

    return (
        <EmptyState
            title={t('calibration.cycle.empty.title')}
            message={t('calibration.cycle.empty.message')}
        />
    );
};
